/**
 * Obtiene la información del usuario desde localStorage
 * @returns {Object|null} - Información del usuario o null si no existe
 */
export const getUserInfo = () => {
    try {
        const storedUserInfo = localStorage.getItem("userInfo")
        if (storedUserInfo) {
            return JSON.parse(storedUserInfo)
        }
        return null
    } catch (error) {
        console.error("Error al obtener información del usuario:", error)
        return null
    }
}

/**
 * Obtiene el token de autenticación
 * @returns {string|null} - Token de autenticación o null si no existe
 */
export const getAuthToken = () => {
    const userInfo = getUserInfo()
    return userInfo?.token || null
}

/**
 * Actualiza la información del usuario en localStorage
 * @param {Object} currentUserInfo - Información actual del usuario
 * @param {Object} newUserData - Nueva información del usuario
 * @returns {boolean} - true si la actualización fue exitosa, false en caso contrario
 */
export const updateUserInfo = (currentUserInfo, newUserData) => {
    if (!currentUserInfo) return false

    try {
        const updatedUserInfo = { ...currentUserInfo, ...newUserData }
        localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo))
        return true
    } catch (error) {
        console.error("Error al actualizar información del usuario:", error)
        return false
    }
}

